/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { EntryPoint } from '@wit/vtv-x-foundation-lib';

enum QueryKeys {
  ENTRY_POINT = 'ep',
  MENU_ID = 'mi',
}

interface QueryParameters {
  entryPoint?: EntryPoint;
  menuItemId?: number;
}

export default class QueryUtils {
  static encodeQueryParameters(query: QueryParameters): string {
    const searchParams = new URLSearchParams();
    if (query.entryPoint !== undefined) {
      searchParams.set(QueryKeys.ENTRY_POINT, query.entryPoint);
    }
    if (query.menuItemId !== undefined) {
      searchParams.set(QueryKeys.MENU_ID, query.menuItemId.toString());
    }
    return searchParams.toString();
  }

  static decodeQueryParameters(query: string): QueryParameters {
    const searchParams = new URLSearchParams(query);
    const params: QueryParameters = {};
    const entryPoint = searchParams.get(QueryKeys.ENTRY_POINT);
    if (entryPoint && Object.values(EntryPoint).includes(entryPoint as EntryPoint)) {
      params.entryPoint = entryPoint as EntryPoint;
    }
    const menuId = searchParams.get(QueryKeys.MENU_ID);
    if (menuId !== undefined && menuId !== null) {
      const parsedMenuId = Number.parseInt(menuId, 10);
      params.menuItemId = Number.isNaN(parsedMenuId) ? undefined : parsedMenuId;
    }
    return params;
  }
}
